import { LabelValueType } from 'src/components/AsyncFormSelect/AsyncFormSelect';

export enum PROVIDER_TYPES {
  ALL = '0',
  KICKERTECH = '56',
  BETBAZAR ='62',
  KIRON ='240',
  KTFEED ='300',
}

export const providerOptionsNoAll: LabelValueType[] = [
  {
    label: 'Kickertech',
    value: PROVIDER_TYPES.KICKERTECH,
  },
  {
    label: 'BetBazar',
    value: PROVIDER_TYPES.BETBAZAR,
  },
  {
    label: 'Kiron',
    value: PROVIDER_TYPES.KIRON,
  },
  {
    label: 'KTFeed',
    value: PROVIDER_TYPES.KTFEED,
  },
];

export const providerOptions: LabelValueType[] = [
  {
    label: 'All',
    value: PROVIDER_TYPES.ALL,
  },
  ...providerOptionsNoAll,
];
